import { render } from "./AttEmp.vue?vue&type=template&id=2d54d085&scoped=true"
import script from "./AttEmp.vue?vue&type=script&lang=js"
export * from "./AttEmp.vue?vue&type=script&lang=js"

import "./AttEmp.vue?vue&type=style&index=0&id=2d54d085&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d54d085"]])

export default __exports__